import {Trans} from 'react-i18next';
import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
const utils = {
  dollarSymbols: {
    AED: 'د.إ',
    AFN: '؋',
    ALL: 'L',
    AMD: 'AMD',
    ANG: 'ƒ',
    AOA: 'Kz',
    ARS: '$',
    AUD: '$',
    AWG: 'ƒ',
    AZN: '₼',
    BAM: 'KM',
    BBD: '$',
    BDT: '৳',
    BGN: 'лв',
    BHD: '.د.ب',
    BIF: 'FBu',
    BMD: '$',
    BND: '$',
    BOB: 'Bs.',
    BRL: 'R$',
    BSD: '$',
    BTC: '฿',
    BTN: 'Nu.',
    BWP: 'P',
    BYR: 'p.',
    BZD: 'BZ$',
    CAD: '$',
    CDF: 'FC',
    CHF: 'Fr.',
    CLP: '$',
    CNY: '¥',
    COP: '$',
    CRC: '₡',
    CUC: '$',
    CUP: '₱',
    CVE: '$',
    CZK: 'Kč',
    DJF: 'Fdj',
    DKK: 'kr',
    DOP: 'RD$',
    DZD: 'دج',
    EEK: 'kr',
    EGP: '£',
    ERN: 'Nfk',
    ETB: 'Br',
    ETH: 'Ξ',
    EUR: '€',
    FJD: '$',
    FKP: '£',
    GBP: '£',
    GEL: '₾',
    GGP: '£',
    GHC: '₵',
    GHS: 'GH₵',
    GIP: '£',
    GMD: 'D',
    GNF: 'FG',
    GTQ: 'Q',
    GYD: '$',
    HKD: '$',
    HNL: 'L',
    HRK: 'kn',
    HTG: 'G',
    HUF: 'Ft',
    IDR: 'Rp',
    ILS: '₪',
    IMP: '£',
    INR: '₹',
    IQD: 'ع.د',
    IRR: '﷼',
    ISK: 'kr',
    JEP: '£',
    JMD: 'J$',
    JOD: 'JD',
    JPY: '¥',
    KES: 'KSh',
    KGS: 'лв',
    KHR: '៛',
    KMF: 'CF',
    KPW: '₩',
    KRW: '₩',
    KWD: 'KD',
    KYD: '$',
    KZT: '₸',
    LAK: '₭',
    LBP: '£',
    LKR: '₨',
    LRD: '$',
    LSL: 'M',
    LTC: 'Ł',
    LTL: 'Lt',
    LVL: 'Ls',
    LYD: 'LD',
    MAD: 'MAD',
    MDL: 'lei',
    MGA: 'Ar',
    MKD: 'ден',
    MMK: 'K',
    MNT: '₮',
    MOP: 'MOP$',
    MUR: '₨',
    MVR: 'Rf',
    MWK: 'MK',
    MXN: '$',
    MYR: 'RM',
    MZN: 'MT',
    NAD: '$',
    NGN: '₦',
    NIO: 'C$',
    NOK: 'kr',
    NPR: '₨',
    NZD: '$',
    OMR: '﷼',
    PAB: 'B/.',
    PEN: 'S/.',
    PGK: 'K',
    PHP: '₱',
    PKR: '₨',
    PLN: 'zł',
    PYG: 'Gs',
    QAR: '﷼',
    RMB: '￥',
    RON: 'lei',
    RSD: 'Дин.',
    RUB: '₽',
    RWF: 'R₣',
    SAR: '﷼',
    SBD: '$',
    SCR: '₨',
    SDG: 'ج.س.',
    SEK: 'kr',
    SGD: '$',
    SHP: '£',
    SLL: 'Le',
    SOS: 'S',
    SRD: '$',
    SSP: '£',
    STD: 'Db',
    SVC: '$',
    SYP: '£',
    SZL: 'E',
    THB: '฿',
    TJS: 'SM',
    TMT: 'T',
    TND: 'د.ت',
    TOP: 'T$',
    TRL: '₤',
    TRY: '₺',
    TTD: 'TT$',
    TVD: '$',
    TWD: 'NT$',
    NTD: 'NT$',
    TZS: 'TSh',
    UAH: '₴',
    UGX: 'USh',
    USD: '$',
    UYU: '$U',
    UZS: 'лв',
    VEF: 'Bs',
    VND: '₫',
    VUV: 'VT',
    WST: 'WS$',
    XAF: 'FCFA',
    XBT: 'Ƀ',
    XCD: '$',
    XOF: 'CFA',
    XPF: '₣',
    YER: '﷼',
    ZAR: 'R',
    ZWD: 'Z$',
  },
  getPlanI18n: (
    functionType = '',
    subscriptionType = '',
    recurringType = '',
    deviceNum = 0
  ) => {
    switch (subscriptionType) {
      case 'ESSENTIAL':
        if (recurringType === 'MONTH') {
          if (functionType === 'SKINCARE_PRO') {
            if (deviceNum === 1) {
              return (
                <Trans i18nKey="p.g.a.changeplan.essential.monthly.device">
                  Essential plan ( {{deviceNum}} device) billed monthly
                </Trans>
              );
            }
            return (
              <Trans i18nKey="p.g.a.changeplan.essential.monthly.licenses">
                Essential plan ( {{deviceNum}} licenses) billed monthly
              </Trans>
            );
          }
          return (
            <Trans i18nKey="p.g.a.changeplan.essential.monthly">
              Essential plan billed monthly
            </Trans>
          );
        }
        if (recurringType === 'QUARTER') {
          if (functionType === 'SKINCARE_PRO') {
            if (deviceNum === 1) {
              return (
                <Trans i18nKey="p.g.a.changeplan.essential.quarterly.device">
                  Essential plan ( {{deviceNum}} device) billed quarterly
                </Trans>
              );
            }
            return (
              <Trans i18nKey="p.g.a.changeplan.essential.quarterly.licenses">
                Essential plan ( {{deviceNum}} licenses) billed quarterly
              </Trans>
            );
          }
          return (
            <Trans i18nKey="p.g.a.changeplan.essential.quarterly">
              Essential plan billed quarterly
            </Trans>
          );
        }
        if (recurringType === 'ANNUAL') {
          if (functionType === 'SKINCARE_PRO') {
            if (deviceNum === 1) {
              return (
                <Trans i18nKey="p.g.a.changeplan.essential.annually.device">
                  Essential plan ( {{deviceNum}} device) billed annually
                </Trans>
              );
            }
            return (
              <Trans i18nKey="p.g.a.changeplan.essential.annually.licenses">
                Essential plan ( {{deviceNum}} licenses) billed annually
              </Trans>
            );
          }
          return (
            <Trans i18nKey="p.g.a.changeplan.essential.annually">
              Essential plan billed annually
            </Trans>
          );
        }
        break;
      case 'PREMIUM':
        if (recurringType === 'MONTH') {
          if (functionType === 'SKINCARE_PRO') {
            if (deviceNum === 1) {
              return (
                <Trans i18nKey="p.g.a.changeplan.premium.monthly.device">
                  Premium plan ( {{deviceNum}} device) billed monthly
                </Trans>
              );
            }
            return (
              <Trans i18nKey="p.g.a.changeplan.premium.monthly.licenses">
                Premium plan ( {{deviceNum}} licenses) billed monthly
              </Trans>
            );
          }
          return (
            <Trans i18nKey="p.g.a.changeplan.premium.monthly">
              Premium plan billed monthly
            </Trans>
          );
        }
        if (recurringType === 'QUARTER') {
          if (functionType === 'SKINCARE_PRO') {
            if (deviceNum === 1) {
              return (
                <Trans i18nKey="p.g.a.changeplan.premium.quarterly.device">
                  Premium plan ( {{deviceNum}} device) billed quarterly
                </Trans>
              );
            }
            return (
              <Trans i18nKey="p.g.a.changeplan.premium.quarterly.licenses">
                Premium plan ( {{deviceNum}} licenses) billed quarterly
              </Trans>
            );
          }
          return (
            <Trans i18nKey="p.g.a.changeplan.premium.quarterly">
              Premium plan billed quarterly
            </Trans>
          );
        }
        if (recurringType === 'ANNUAL') {
          if (functionType === 'SKINCARE_PRO') {
            if (deviceNum === 1) {
              return (
                <Trans i18nKey="p.g.a.changeplan.premium.annually.device">
                  Premium plan ( {{deviceNum}} device) billed annually
                </Trans>
              );
            }
            return (
              <Trans i18nKey="p.g.a.changeplan.premium.annually.licenses">
                Premium plan ( {{deviceNum}} licenses) billed annually
              </Trans>
            );
          }
          return (
            <Trans i18nKey="p.g.a.changeplan.premium.annually">
              Premium plan billed annually
            </Trans>
          );
        }
        break;
      default:
        return;
    }
  },
  getSubscriptionTypeI18n: type => {
    switch (type.toUpperCase()) {
      case 'ESSENTIAL_TRIAL':
        return (
          <Trans i18nKey="p.g.a.updateaccount.essential.trial.plan">
            Essential Trial Plan
          </Trans>
        );
      case 'PREMIUM_TRIAL':
        return (
          <Trans i18nKey="p.g.a.updateaccount.premium.trial.plan">
            Premium Trial Plan
          </Trans>
        );
      case 'ESSENTIAL':
        return (
          <Trans i18nKey="p.g.a.updateaccount.essential">Essential Plan</Trans>
        );
      case 'PREMIUM':
        return (
          <Trans i18nKey="p.g.a.updateaccount.premium">Premium Plan</Trans>
        );
      case 'ENTERPRISE':
        return (
          <Trans i18nKey="p.g.a.updateaccount.enterprise">
            Enterprise Plan
          </Trans>
        );
      default:
        return;
    }
  },
  getRecurringTypeI18n: type => {
    switch (type.toUpperCase()) {
      case 'MONTH':
        return <Trans i18nKey="p.g.a.updateaccount.monthly">Monthly</Trans>;
      case 'QUARTER':
        return <Trans i18nKey="p.g.a.updateaccount.quarterly">Quarterly</Trans>;
      case 'ANNUAL':
        return <Trans i18nKey="p.g.a.updateaccount.annually">Annually</Trans>;
      default:
        return;
    }
  },
  getPayStatusI18n: payStatus => {
    switch (payStatus.toUpperCase()) {
      case 'PAID':
        return <Trans i18nKey="p.g.a.updateaccount.paystatus.paid">PAID</Trans>;
      case 'CANCELLED':
        return (
          <Trans i18nKey="p.g.a.updateaccount.paystatus.cancelled">
            CANCELLED
          </Trans>
        );
      case 'FAILED':
        return (
          <Trans i18nKey="p.g.a.updateaccount.paystatus.failed">FAILED</Trans>
        );
      case 'PROCESSING':
        return (
          <Trans i18nKey="p.g.a.updateaccount.paystatus.processing">
            PROCESSING
          </Trans>
        );
      case 'REFOUNDED':
        return (
          <Trans i18nKey="p.g.a.updateaccount.paystatus.refunded">
            REFUNDED
          </Trans>
        );
      default:
        return;
    }
  },
  getChosenPlanInfo: (functionType, params, plans) => {
    const {currency, recurringType, subscriptionType, numOfDevices} = params;
    if (functionType === 'SKINCARE_PRO') {
      for (const key in plans) {
        if (
          key.includes(recurringType) &&
          key.includes(subscriptionType) &&
          key.includes(numOfDevices)
        ) {
          return _get(plans, `${key}.price.${currency}`, null);
        }
      }
    }
    for (const key in plans) {
      if (key.includes(recurringType) && key.includes(subscriptionType)) {
        return _get(plans, `${key}.price.${currency}`, null);
      }
    }
    return null;
  },
  findMinimumPlan: (
    functionType = 'MAKEUP',
    allPlans = {},
    recurringType,
    subscriptionType,
    numOfDevices
  ) => {
    const planSubscriptionTypes = ['ESSENTIAL', 'PREMIUM'];
    const planRecurringTypes = ['MONTH', 'ANNUAL'];
    const nums = [1, 3, 5, 7];

    if (_isEmpty(allPlans)) return {};

    if (functionType === 'SKINCARE_PRO') {
      if (subscriptionType && recurringType) {
        if (numOfDevices) {
          const key = `${recurringType}_${subscriptionType}_${numOfDevices}`;
          if (allPlans.hasOwnProperty(key)) {
            return {
              productId: allPlans[key].productId,
              isUpgrade: allPlans[key].isUpgrade || false,
              recurringType,
              subscriptionType,
              numOfDevices: numOfDevices,
            };
          }
        }

        for (const num of nums) {
          const key = `${recurringType}_${subscriptionType}_${num}`;
          if (allPlans.hasOwnProperty(key)) {
            return {
              productId: allPlans[key].productId,
              isUpgrade: allPlans[key].isUpgrade || false,
              recurringType,
              subscriptionType,
              numOfDevices: num,
            };
          }
        }
      }
      if (recurringType) {
        for (const num of nums) {
          for (const planSubscriptionType of planSubscriptionTypes) {
            const key = `${recurringType}_${planSubscriptionType}_${num}`;
            if (allPlans.hasOwnProperty(key)) {
              return {
                productId: allPlans[key].productId,
                isUpgrade: allPlans[key].isUpgrade || false,
                recurringType,
                subscriptionType: planSubscriptionType,
                numOfDevices: num,
              };
            }
          }
        }
      }
      return {};
    }
    if (subscriptionType && recurringType) {
      const key = `${recurringType}_${subscriptionType}`;
      if (allPlans.hasOwnProperty(key)) {
        return {
          productId: allPlans[key].productId,
          isUpgrade: allPlans[key].isUpgrade || false,
          recurringType,
          subscriptionType,
        };
      }
    }
    if (recurringType) {
      for (const planSubscriptionType of planSubscriptionTypes) {
        const key = `${recurringType}_${planSubscriptionType}`;
        if (allPlans.hasOwnProperty(key)) {
          return {
            productId: allPlans[key].productId,
            isUpgrade: allPlans[key].isUpgrade || false,
            recurringType,
            subscriptionType: planSubscriptionType,
          };
        }
      }
    }

    for (const subscriptionType of planSubscriptionTypes) {
      for (const recurringType of planRecurringTypes) {
        const key = `${recurringType}_${subscriptionType}`;
        if (allPlans.hasOwnProperty(key)) {
          return {
            productId: allPlans[key].productId,
            isUpgrade: allPlans[key].isUpgrade || false,
            recurringType,
            subscriptionType,
          };
        }
      }
    }

    return {};
  },

  calcReportCount: (
    functionType = 'SKINCARE_PRO',
    subscriptionType = 'ESSENTIAL',
    numOfDevices = 1
  ) => {
    if (functionType !== 'SKINCARE_PRO') {
      return 0;
    }
    if (subscriptionType === 'ESSENTIAL') {
      return 2000 + numOfDevices * 1000;
    }
    if (subscriptionType === 'PREMIUM') {
      return 4000 + numOfDevices * 1000;
    }
    return 0;
  },
};
export default utils;
